import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const HeaderBar = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  minHeight: '53px',
}));
